import React from 'react';
import { Link } from 'react-router-dom';
import { Table, Button, Tooltip, Row, Col, Space } from 'antd';
import { PlusOutlined, FileExcelOutlined } from '@ant-design/icons';
import { DatePopupconfirm } from '../../../components/datePopupConfirm';
import dayjs from 'dayjs';

export default function CustomerList({ customers, onEdit, markInactive, onAdd, loading }) {
  const columns = [
    { title: 'Code', dataIndex: 'code', key: 'code' },
    {
      title: 'Customer Name',
      dataIndex: 'name',
      key: 'name',
      render: (value) => {
        const split = String(value).split('\n');
        const nameSplit = split.map((line, idx) => {
          return <div key={idx}>{line}</div>
        });
        return (<>
          {nameSplit}
        </>)
      },
    },
    { title: 'Contact Person Name', dataIndex: 'contact_person', key: 'contact_person' },
    { title: 'Email', dataIndex: 'email', key: 'email' },
    { title: 'Address', dataIndex: 'address', key: 'address' },
    { title: 'City', dataIndex: 'city', key: 'city' },
    { title: 'State', dataIndex: 'state', key: 'state' },
    { title: 'Zip', dataIndex: 'zip', key: 'zip' },
    { title: 'Country', dataIndex: 'country', key: 'country' },
    // { title: 'Invoice Due Days', dataIndex: 'invoice_due_days', key: 'invoice_due_days' },
    {
      title: 'Actions', key: 'actions',
      render: (_, record) => (
        <Space gap="small" wrap>
          <Link to={`/customers/${record.id}`}><Button onClick={() => false}>View</Button></Link>
          <Button onClick={() => onEdit(record)}>Edit</Button>
          <Tooltip placement='left' title={ !record.is_active ? `Deactivation Effective Date: ${dayjs(record.last_deactivation_date).format('MM/DD/YYYY')}` : '' }>
            <span>
              <DatePopupconfirm
                onConfirm={markInactive}
                customerId={null}
                record_id={record.id}
                is_active={record.is_active}
              />
            </span>
          </Tooltip>
        </Space>
      )
    }
  ];

  return (
    <>
      <Row justify="end" gutter={8}>
        <Col>
          <Button type="primary" onClick={onAdd} icon={<PlusOutlined />} className='mb-16'>
            ADD CUSTOMER
          </Button>
        </Col>
        {/* <Col>
          <Link to="/customers/import">
            <Button type="primary" icon={<FileExcelOutlined />} className='mb-16'>
              IMPORT CUSTOMER
            </Button>
          </Link>
        </Col> */}
      </Row>
      <Table
        dataSource={customers}
        columns={columns}
        rowKey="id"
        loading={loading}
        scroll={{ x: 'max-content' }}
        size="small"
        pagination={customers?.length > 10 || false}
      />
    </>
  );
}
